import { Grid } from "@material-ui/core";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import constants from "constants";
import React from "react";
import { Bar } from "react-chartjs-2";
import { useHistory } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);


function calculateTotalBySectorsAndCategory(sectors, category, data) {
  return sectors.map(
    (_sector) =>{
      let result = data.filter(
        (_data) => _data.category === category && _data.sector === _sector
      )
      return  result.length > 0 ? result[0].total : [];
    }
  );
}

const StatisticsChart = (props) => {
  const [data, setData] = React.useState({ labels: [], datasets: [] });
  const history = useHistory();

  // Al hacer clic sobre una barra se navega al detalle estadístico de esa
  // categoría, llevando el filtro actual (fechas y sectores) para conservar
  // el contexto de la consulta.
  const options = {
    responsive: true,
    onClick: (event, elements, chart) => {
      if (!elements || elements.length === 0) return;
      const datasetIndex = elements[0].datasetIndex;
      const category = chart.data.datasets[datasetIndex].label;
      if (!category) return;
      const filter = props.currentFilter || null;
      // Se difiere la navegación para que Chart.js termine de procesar el
      // evento actual antes de que esta vista (y el gráfico) se desmonten. De
      // lo contrario Chart.js sigue notificando a sus plugins sobre un gráfico
      // ya destruido y lanza:
      // "Cannot read properties of undefined (reading 'handleEvent')".
      setTimeout(() => {
        history.push("/estadistica/detalle", {
          category: category,
          filter: filter,
        });
      }, 0);
    },
    onHover: (event, elements) => {
      if (event && event.native && event.native.target) {
        event.native.target.style.cursor =
          elements && elements.length ? "pointer" : "default";
      }
    },
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: false,
      },
    },
  };

  function generateData(apiData) {
    let labels = Array.from(new Set(apiData.map((item) => item.sector)));
    let dataLabels = Array.from(new Set(apiData.map((item) => item.category)));
    let datasets = dataLabels.map((item, index) => {
      return {
        label: item,
        data: calculateTotalBySectorsAndCategory(labels, item, apiData),
        backgroundColor:
        constants.colors.length > index ? constants.colors[index] : constants.randColor(),
      };
    });

    setData({
      labels: labels,
      datasets: datasets,
    });
  }

  React.useEffect(() => {
    generateData(props.data);
  }, [props.data]);

  return (
    <Grid item xs={12}>
      <div
        style={{
          minHeight: "50vh",
          padding: "5vh",
          width: "100%",
          minWidth: "720px",
        }}
      >
        <Bar options={options} data={data} />
      </div>
    </Grid>
  );
};

export default StatisticsChart;
